var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"}),_vm._v(" "),_c('strong',[_vm._v("Copyright © "+_vm._s(_vm.annee)+" "),_c('a',{attrs:{"href":"http://www.abft.be"}},[_vm._v("A.B.F.T.")])]),_vm._v(" All rights reserved.\n  "),_c('strong',{staticClass:"pull-right"},[_vm._v("V"+_vm._s(_vm.getProdVersion))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dcbcba5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Communs/Footer.vue
// module id = null
// module chunks = 